import { render, staticRenderFns } from "./Creatives.vue?vue&type=template&id=fd996272"
import script from "./Creatives.vue?vue&type=script&lang=js"
export * from "./Creatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports